

import WebServiceRequest from '../../Api/WebServiceRequest'

class CloseTicket extends WebServiceRequest {
    constructor (context) {
        super(context)
    }
    setId(data){
        super.setTag(`Ticket/CloseTicket?parentId=${data.ticketId}`)
    }
}
export default CloseTicket;
